/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppAlert } from "../../../components/dialogue/Dialogue";
// import { useAppSelector } from "../../../redux/hooks";
import { ProjectTable } from "./ProjectTable";
import { setProjects } from "../../../redux/reducers";
import { Container } from "../../../globalstyled";
import AppLoader from "../../../components/loader";
import { useFetchProjects } from "../../../apolloClient/hooks/general/fetchHook";
import { useAccess } from "../../../hooks/useAccess";
import { useLocation } from "react-router-dom";

interface DashboardProps {}

const filterIdMap: Record<string, number> = {
  setup: 1,
  "Filed insurance claim": 101,
  planning: 2,
  "Uploaded Insurance Scope": 201,
  "Pending Admin Measurement Input": 202,
  ordering: 3,
  "Selected materials": 301,
  "Selected Contractors": 302,
  "Signed Estimate": 303,
  "Selected Install Date": 304,
  "Payment Made": 305,
  construction: 4,
  completion: 5,
  archive: 6,
};

export const Projects: React.FC<DashboardProps> = ({}) => {
  const [mainFilter, setMainFilter] = useState<string>("all");
  const [subFilter, setSubFilter] = useState<string | undefined>(undefined);
  const dispatch = useDispatch();
  // const userReducer = useAppSelector((state) => state.userReducer);
  // const { projects } = userReducer;

  const getStatusFromFilter = (main: string, sub?: string): string | undefined => {
    if (main === "all") return undefined;
    if (main === "archive") return "Archived";
    if (!sub) {
      switch (main) {
        case "setup": return "ProjectSetup";
        case "planning": return "ProjectPlanning";
        case "ordering": return "Ordering";
        case "construction": return "Construction";
        case "completion": return "Completion";
        default: return undefined;
      }
    }
    const map: Record<string, string> = {
      "Filed insurance claim": "InsuranceClaimFiled",
      "Uploaded Insurance Scope": "InsuranceScopeUploaded",
      "Pending Admin Measurement Input": "AdminMeasurementInput",
      "Selected materials": "MaterialsSelected",
      "Selected Contractors": "ContractorsSelected",
      "Signed Estimate": "EstimateSigned",
      "Selected Install Date": "InstallDateSelected",
      "Payment Made": "PaymentMade",
    };
    return map[sub] || undefined;
  };

  const getReasonFromFilter = (main: string, sub?: string): string | undefined => {
    if (main !== "archive" || !sub) return undefined;
    const map: Record<string, string> = {
      "Do not contact": "DoNotContact",
      "Customer stopped communicating": "CustomerStoppedCommunicating",
      "Project completed": "ProjectCompleted",
      "Unable to collect": "UnableToCollect",
      "Cancelled project": "CancelledProject",
      "Unserviceable Request": "UnserviceableRequest",
      "Test Project": "TestProject",
      "Other": "Other",
    };
    return map[sub] || undefined;
  };

  // Only compute status, reason, id if not "all"
  const status = mainFilter === "all" ? undefined : getStatusFromFilter(mainFilter, subFilter);
  const reason = mainFilter === "all" ? undefined : getReasonFromFilter(mainFilter, subFilter);
  const id =
    mainFilter === "all"
      ? undefined
      : subFilter && filterIdMap[subFilter]
      ? filterIdMap[subFilter]
      : filterIdMap[mainFilter] || undefined;

  const {
    loading,
    error,
    projects: projectsDetails,
    refetch,
  } = useFetchProjects(500, 0, status, reason, id);

  const location = useLocation();


  useEffect(() => {
    if (!loading && !error && projectsDetails) {
      dispatch(setProjects(projectsDetails));
    }
  }, [loading, error, projectsDetails, dispatch]);

  useEffect(() => {
    refetch();
  }, [location, status, reason, refetch]);

  const { loading: accessLoading } = useAccess();

  // Only show full-page loader for access loading
  if (accessLoading) {
    return <AppLoader isLoading={true} />;
  }

  const hostContainer = () => {
    return (
      <Container>
        <AppAlert
          open={false}
          title={`Reset Password!`}
          message={"Are you sure to Reset Your Password?"}
          onClose={() => {}}
          onConfirm={() => {}}
        />
        <ProjectTable
          projects={projectsDetails}
          mainFilter={mainFilter}
          setMainFilter={setMainFilter}
          subFilter={subFilter}
          setSubFilter={setSubFilter}
          loading={loading}
        />
      </Container>
    );
  };

  return hostContainer();
};
